module.exports = __webpack_public_path__ + "static/media/090-airplane.12193686.svg";